import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DashboardRoutingModule } from './dashboard-routing.module';
import {DashboardComponent} from './dashboard.component';
import {RouterModule} from '@angular/router';
import {LoadingSpinnerModule} from '../shared/loading/loading-spinner/loading-spinner.module';
import {DashboardCardComponent} from './dashboard-card/dashboard-card.component';
import {DashboardErrorComponent} from './dashboard-error/dashboard-error.component';


@NgModule({
  declarations: [
      DashboardComponent,
      DashboardCardComponent,
      DashboardErrorComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        DashboardRoutingModule,
        LoadingSpinnerModule
    ],
  exports: [
    DashboardComponent
  ]
})
export class DashboardModule { }
